import React from 'react'
import AnmeldungBereich from "./AnmeldungBereich";
import TeilnehmerBereich from "./TeilnehmerBereich";
import LigaspieltagSpieleBereich from "./LigaspieltagSpieleBereich";
import PublicAnyGamesTab from "../tournaments/PublicAnyGamesTab";
import PublicLigaSpieltageTab from "../tournaments/PublicLigaSpieltageTab";
import PublicLigaTabelleTab from "../tournaments/PublicLigaTabelleTab";
import RanglisteBereich from "./RanglisteBereich";
import PlatzierungBereich from "./PlatzierungBereich";
import PublicTournamentGroupsTab from "../tournaments/PublicTournamentGroupsTab";
import PublicTournamentKratzerGamesTab from "../tournaments/PublicTournamentKratzerGamesTab";
import HighlightsBereich from "./HighlightsBereich";
import StatistikBereich from "./StatistikBereich";
import VergleichBereich from "./VergleichBereich";
import VerlaufBereich from "./VerlaufBereich";
import LiveBereich from "./LiveBereich";
import LigaspieltagEdartDetailStatisikArea from "../../tournament/LigaspieltagEdartDetailStatisikArea";
import {TOURNAMENTSYSTEMS} from "../../../../constants/tournamentSystems";
import TurnierbaumBereich from "./TurnierbaumBereich";
import AlleBaeumeBereich from "./AlleBaeumeBereich";
import VollbildBereich from "./VollbildBereich";
import SchweizerRundenBereich from "./SchweizerRundenBereich";
import GruppenBereich from "./GruppenBereich";

/**
 * Zeigt den Inhalt eines Unterpunkts. Es werden die Komponenten der alten Ansicht unverändert verwendet,
 * nur Teilnehmer, Ligaspieltag-Spiele, Highlights, Statistik, Vergleich, Verlauf, Platzierung und Rangliste haben eigene Komponenten im neuen Design.
 */
export default function BereichInhalt({sub, tournamentWrapper, liveGames, userId, isLoggedIn, appCall, tournamentId,
                                          supportsWebPush, pushSpielerIds, updateSubscriptions, markierterSpieler, onRefresh}) {

    const t = tournamentWrapper.turnierMain;

    const isUserTeilnehmer = () => {
        if (userId === undefined || userId === null) {
            return false;
        }
        return t.tournamentPlayerEntities.some(player => player.userId === userId);
    }

    switch (sub) {
        case "anmeldung":
            return <AnmeldungBereich t={t} isLoggedIn={isLoggedIn} isUserTeilnehmer={isUserTeilnehmer()} onRefresh={onRefresh}/>;
        case "teilnehmer":
            if (t.turniersystem === TOURNAMENTSYSTEMS.LIGASPIELTAG.id) {
                return <TeilnehmerBereich tournamentId={t.id} participants={t.tournamentPlayerEntities} ligaspieltag={true}/>;
            }
            return <TeilnehmerBereich tournamentId={t.id}
                                      tournamentGroupEntities={t.tournamentGroupEntities}
                                      maxAnzahlTeilnehmer={t.maxAnzahlTeilnehmer}
                                      participants={t.tournamentPlayerEntities}
                                      playersSortedByTime={t.playersSortedByTime}
                                      isBezahlung={t.bezahlung} isParticipantsMailConfirmation={t.participantsMailConfirmation}
                                      supportsWebPush={supportsWebPush} pushSpielerIds={pushSpielerIds} updateSubscriptions={updateSubscriptions}/>;
        case "ligaspieltaggames":
            return <LigaspieltagSpieleBereich tournament={t} liveGames={liveGames} boardGames={tournamentWrapper.boardGames}/>;
        case "anygames":
            return <PublicAnyGamesTab tournament={t} games={tournamentWrapper.tournamentAnyGames} boardGames={tournamentWrapper.boardGames}/>;
        case "ligaspieltage":
            return <PublicLigaSpieltageTab tournament={t} boardGames={tournamentWrapper.boardGames}/>;
        case "ligatabelle":
            return <PublicLigaTabelleTab tournament={t} gruppenTabellen={tournamentWrapper.gruppenTabellen}/>;
        case "rangliste":
            return <RanglisteBereich participants={t.tournamentPlayerEntities} eventOperatorId={t.eventOperatorId} rankingId={t.ranglisteId}/>;
        case "platzierung":
            return <PlatzierungBereich tournamentId={t.id}/>;
        case "gruppen":
            // Gruppen im Gruppenturnier bzw. Runden im Schweizer System, beide mit Vollbild
            if (t.turniersystem === TOURNAMENTSYSTEMS.SCHWEIZERSYSTEM.id) {
                return <VollbildBereich appCall={appCall} titel={t.bezeichnung + " – Runden"}>
                    <SchweizerRundenBereich tournament={tournamentWrapper.turnierGruppe} gruppenTabellen={tournamentWrapper.gruppenTabellen}
                                            boardGames={tournamentWrapper.boardGames} liveGames={liveGames}/>
                </VollbildBereich>;
            }
            // Gruppen mit Tabelle und Spielen; Gruppen als KO/DKO (Auslosung je Gruppe) vorerst noch in der alten Darstellung
            if (!tournamentWrapper.turnierGruppe.tournamentAuslosungEntities || tournamentWrapper.turnierGruppe.tournamentAuslosungEntities.length === 0) {
                return <VollbildBereich appCall={appCall} titel={t.bezeichnung + " – Gruppen"}>
                    <GruppenBereich tournament={tournamentWrapper.turnierGruppe} gruppenTabellen={tournamentWrapper.gruppenTabellen}
                                    bestplatzierteDtos={tournamentWrapper.bestplatzierteDtos}
                                    boardGames={tournamentWrapper.boardGames} liveGames={liveGames} userId={userId}/>
                </VollbildBereich>;
            }
            return <VollbildBereich appCall={appCall} titel={t.bezeichnung + " – Gruppen"}>
                <PublicTournamentGroupsTab tournament={tournamentWrapper.turnierGruppe} tournamentWrapper={tournamentWrapper} gruppenTabellen={tournamentWrapper.gruppenTabellen}
                                           bestplatzierteDtos={tournamentWrapper.bestplatzierteDtos}
                                           boardGames={tournamentWrapper.boardGames}
                                           liveGames={liveGames}
                                           gruppeModelWrapperListe={tournamentWrapper.gruppeModelWrapperListe}/>
            </VollbildBereich>;
        case "baum":
            return <TurnierbaumBereich appCall={appCall} tournament={tournamentWrapper.turnierKO} model={tournamentWrapper.modelKO}
                                       boardGames={tournamentWrapper.boardGames} liveGames={liveGames}
                                       boardReihenfolge={tournamentWrapper.boardReihenfolgeKO}
                                       tournamentBeschreibungen={tournamentWrapper.tournamentBeschreibungenKO}/>;
        case "silberturnier":
            return <TurnierbaumBereich appCall={appCall} tournament={tournamentWrapper.turnierSilber} model={tournamentWrapper.modelTurnierSilber}
                                       boardGames={tournamentWrapper.boardGames} liveGames={liveGames}
                                       boardReihenfolge={tournamentWrapper.boardReihenfolgeSilberTurnier}
                                       tournamentBeschreibungen={tournamentWrapper.tournamentBeschreibungenSilberTurnier}/>;
        case "bronzeturnier":
            return <TurnierbaumBereich appCall={appCall} tournament={tournamentWrapper.turnierBronze} model={tournamentWrapper.modelTurnierBronze}
                                       boardGames={tournamentWrapper.boardGames} liveGames={liveGames}
                                       boardReihenfolge={tournamentWrapper.boardReihenfolgeBronzeTurnier}
                                       tournamentBeschreibungen={tournamentWrapper.tournamentBeschreibungenBronzeTurnier}/>;
        case "alleBaeume":
            return <AlleBaeumeBereich boardGames={tournamentWrapper.boardGames} liveGames={liveGames}
                                      tournamentId={t.id} eventOperatorId={t.eventOperatorId} appCall={appCall} baeume={[
                {key: "gold", farbe: tournamentWrapper.turnierSilber ? "gold" : undefined, tournament: tournamentWrapper.turnierKO, model: tournamentWrapper.modelKO,
                    boardReihenfolge: tournamentWrapper.boardReihenfolgeKO, beschreibungen: tournamentWrapper.tournamentBeschreibungenKO},
                {key: "silver", farbe: "silver", tournament: tournamentWrapper.turnierSilber, model: tournamentWrapper.modelTurnierSilber,
                    boardReihenfolge: tournamentWrapper.boardReihenfolgeSilberTurnier, beschreibungen: tournamentWrapper.tournamentBeschreibungenSilberTurnier},
                {key: "bronze", farbe: "bronze", tournament: tournamentWrapper.turnierBronze, model: tournamentWrapper.modelTurnierBronze,
                    boardReihenfolge: tournamentWrapper.boardReihenfolgeBronzeTurnier, beschreibungen: tournamentWrapper.tournamentBeschreibungenBronzeTurnier},
            ].filter(baum => baum.tournament !== null && baum.tournament !== undefined)}/>;
        case "kratzergames":
            return <PublicTournamentKratzerGamesTab tournament={t}
                                       aktuelleRunde={tournamentWrapper.kratzerDto.aktuelleRunde} gewinnerPlayerId={tournamentWrapper.kratzerDto.gewinnerPlayerId}
                                       tournamentPlayers={t.tournamentPlayerEntities}
                                       tournamentKratzerGames={tournamentWrapper.kratzerDto.tournamentKratzerGameEntities}
                                       tournamentKratzerGamePlayers={tournamentWrapper.kratzerDto.tournamentKratzerGamePlayerEntities}
                                       restpunkteDtos={tournamentWrapper.kratzerDto.restpunkteDtos} onCallbackReload={onRefresh}/>;
        case "highlights":
            return <HighlightsBereich tournamentWrapper={tournamentWrapper} markierterSpieler={markierterSpieler}/>;
        case "statistik":
            return <StatistikBereich tournamentId={t.id} participants={t.tournamentPlayerEntities}
                                     gesamtStatistik={tournamentWrapper.ranglisteWrapper.statistikDto} playerStatistiks={tournamentWrapper.ranglisteWrapper.playerStatistiks}/>;
        case "vergleich":
            return <VergleichBereich participants={t.tournamentPlayerEntities} playerStatistiks={tournamentWrapper.ranglisteWrapper.playerStatistiks}/>;
        case "verlauf":
            return <VerlaufBereich tournamentId={t.id} aktualisierung={getAnzahlBeendeterSpiele(tournamentWrapper)} markierterSpieler={markierterSpieler}/>;
        case "live":
            return <LiveBereich appCall={appCall} tournamentId={t.id} eventOperatorId={t.eventOperatorId} titel={t.bezeichnung}/>;
        case "edartstatistik":
            return <LigaspieltagEdartDetailStatisikArea tournamentId={t.id} players={t.tournamentPlayerEntities}
                                           games={t.tournamentLeagueGameEntities} publicView={true}/>;
        default:
            return null;
    }
}

// ändert sich, sobald ein Spiel beendet wurde; der Verlauf lädt dann neu, nicht bei jedem Live-Update
function getAnzahlBeendeterSpiele(tournamentWrapper) {
    const statistiken = tournamentWrapper.ranglisteWrapper ? tournamentWrapper.ranglisteWrapper.playerStatistiks : undefined;
    return (statistiken || []).reduce((summe, s) => summe + s.gewonneneSpiele + s.verloreneSpiele + s.unentschiedenSpiele, 0);
}
